require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./total-indian-foodie.json") })
        }
      }, "path---total-indian-foodie");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---total-indian-foodie!./.cache/json/total-indian-foodie.json
// module id = 748
// module chunks = 231608221292675